import { Flex, Icon } from '@vibe/core';
import { MoveArrowRight, Subitems } from '@vibe/icons';
import { BoardSourceExplainer } from './common';

export function SubitemsBoardSourceExplainer() {
  return (
    <BoardSourceExplainer
      title="Clients see only their own subitems in the client portal"
      description="Each client will see the subitems under their own client item on the Clients Board."
      videoSrc="/Onboarding-Client-Subitems-Compressed.mp4"
    />
  );
}

export function SubitemsSourceIndicator({ children }: { children: React.ReactNode }) {
  return (
    <Flex gap={2}>
      <Flex gap={2}>
        <div
          style={{
            transform: 'translate3d(0,1px,0)',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="#323338" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.74687 4.0502H14.3969C14.6454 4.0502 14.8469 4.25167 14.8469 4.5002L14.9194 7C15.3983 7.07779 15.799 7.4965 16.1969 7.74296V4.5002C16.1969 3.50608 15.391 2.7002 14.3969 2.7002H3.59687C2.60276 2.7002 1.79688 3.50608 1.79688 4.5002V13.5002C1.79688 14.4943 2.60276 15.3002 3.59687 15.3002H8.44597L9.44597 13.9502H6.74687V4.0502ZM5.39687 4.0502H3.59687C3.34835 4.0502 3.14687 4.25167 3.14687 4.5002V13.5002C3.14687 13.7487 3.34835 13.9502 3.59687 13.9502H5.39687V4.0502Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.5003 8C12.8169 8 12.1615 8.2553 11.6782 8.70974C11.195 9.16418 10.9235 9.78053 10.9235 10.4232C10.9235 11.0659 11.195 11.6822 11.6782 12.1367C12.1615 12.5911 12.8169 12.8464 13.5003 12.8464C14.1838 12.8464 14.8392 12.5911 15.3224 12.1367C15.8057 11.6822 16.0772 11.0659 16.0772 10.4232C16.0772 9.78053 15.8057 9.16418 15.3224 8.70974C14.8392 8.2553 14.1838 8 13.5003 8ZM13.227 13.4426H13.7764C14.5202 13.4689 15.2475 13.6562 15.9018 13.99C16.5276 14.3068 17.057 14.7686 17.44 15.3317C17.8073 15.8809 18 16.4997 18 17.1285V17.5599C18 17.8031 17.764 18 17.472 18H9.52804C9.23602 18 9 17.8031 9 17.5599V17.1285C9 16.4997 9.19268 15.8809 9.56004 15.3317C9.94318 14.7686 10.4728 14.3068 11.0988 13.99C11.7537 13.6559 12.4825 13.4686 13.227 13.4426Z"
            />
          </svg>
        </div>
        <Icon icon={MoveArrowRight} size={12} />
        <Icon icon={Subitems} size={17} />
      </Flex>
      <div style={{ marginRight: '8px', marginLeft: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {children}
      </div>
    </Flex>
  );
}
